import React from 'react';
import { motion } from 'framer-motion';
import { TOOLS } from '../data/content';

export default function Tools() {
  return (
    <section id="tools" className="py-24 md:py-32 bg-page">
      <div className="container-x">
        <div className="max-w-3xl">
          <div className="section-label">{TOOLS.eyebrow}</div>
          <h2 className="font-display text-[42px] md:text-[56px] leading-[1.02] mt-5">
            {TOOLS.title}
            <span className="grad-text-red">{TOOLS.titleAccent}</span>
          </h2>
        </div>

        <div className="mt-14 grid sm:grid-cols-2 md:grid-cols-3 gap-4">
          {TOOLS.tools.map((t, i) => (
            <motion.div
              key={t.name}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: '-80px' }}
              transition={{ duration: 0.5, delay: i * 0.05 }}
              className="card-lift bg-white border border-line rounded-2xl p-6 flex items-center justify-between group"
            >
              <div>
                <div className="font-display text-[28px] text-[color:var(--ink)] group-hover:text-red transition-colors">
                  {t.name}
                </div>
                <div className="text-[13px] text-[color:var(--muted)] mt-1">{t.sub}</div>
              </div>
              <div className="font-display text-[color:var(--muted)] text-sm">{t.n}</div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
}
